import type { Dictionary } from '@/constants/content/en'

export const zhTw: Dictionary = {
    meta: {
        description: "全球限量 199 輛獨立編號。S-Works Tarmac SL9 LTD Built for Legends：手工 Race Red 塗裝、客製化 SRAM RED AXS、整車 6.6 公斤，以及 Specialized 史上最短的完賽時間。",
        ogLocale: "zh_TW",
        notFound: {
            title: "找不到頁面",
            eyebrow: "錯誤 404",
            heading: "這個頁面已脫離主集團。",
            body: "您要找的頁面不存在，或已經移動。",
            cta: "回到首頁"
        },
        serverError: {
            title: "發生錯誤",
            eyebrow: "錯誤 500",
            heading: "我們遇到了機械故障。",
            body: "我們這邊出了點問題，請稍後再試。",
            cta: "回到首頁"
        }
    },
    nav: {
        links: [
            { href: '/#story', label: "故事" },
            { href: '/#craft', label: "工藝" },
            { href: '/#racing', label: "賽事" },
            { href: '/#time-to-finish', label: "科技" },
            { href: '/#specs', label: "規格" },
            { href: '/#geometry', label: "幾何" },
            { href: '/configurator', label: "C72 客製化" }
        ],
        cta: "登記購買意願",
        openMenu: "開啟選單",
        closeMenu: "關閉選單",
        language: "語言",
        primary: "主要導覽",
        skip: "跳至主要內容"
    },
    hero: {
        eyebrow: "限量版本 · 全球僅 199 輛獨立編號",
        titleSmall: "S-Works Tarmac SL9 LTD",
        titleLarge: "Built for Legends",
        lead: "一輛自行車統領一切。以手工完成的 Race Red 塗裝，向 Tarmac 無與倫比的勝利傳奇致敬。",
        priceLabel: "售價",
        colorLabel: "顏色",
        colorValue: "Race Red",
        sizesLabel: "尺寸",
        ctaPrimary: "登記購買意願",
        ctaSecondary: "探索車款",
        imageAlt: "Race Red 塗裝的 S-Works Tarmac SL9 LTD Built for Legends 側面"
    },
    stats: [
        { value: "199", unit: "", label: "全球限量獨立編號" },
        { value: "687", unit: "g", label: "FACT 12r 碳纖維車架（56 尺寸）" },
        { value: "6.6", unit: "kg", label: "整車重量（56 尺寸）" },
        { value: "4", unit: "W", label: "時速 45 公里下比 SL8 減少的風阻" }
    ],
    ticker: ["Built for Legends", "全球限量 199 輛", "一輛自行車統領一切", "Made in Racing Red", "完賽時間"],
    story: {
        eyebrow: "一輛自行車統領一切",
        title: "Specialized 迄今速度最快的公路自行車。",
        paragraphs: [
            "全新 S-Works Tarmac SL9 是 Specialized 迄今打造速度最快的公路自行車。不只是因為重量輕盈，不只是因為擁有 Tarmac 史上最出色的空力性能，也不只是因為卓越的操控表現，而是因為在 Specialized 測試過的所有公路自行車中，它的實際完賽時間最短。",
            "Built for Legends LTD 以專屬配色、客製化全黑 SRAM RED AXS 傳動套件與紅色煞車卡鉗，以及取材自這項運動中最具冠軍實績之競賽車款的獨特細節，向 Tarmac 無與倫比的勝利傳奇致敬。全球限量 199 輛獨立編號；一旦售完，便成絕版。",
            "Tarmac SL9 將更多踩踏力量轉化為純粹速度，並已在真實賽道、真實地形與真實車手身上獲得驗證。當目標是率先衝過終點線，沒有任何公路自行車能更快帶您抵達。"
        ],
        glance: {
            title: "規格速覽",
            rows: [
                { label: "用途", value: "公路賽" },
                { label: "獨家 LTD 版本", value: "僅 199 輛獨立編號的自行車" },
                { label: "車架", value: "FACT 12r 碳纖維車架：687 公克" },
                { label: "車輪／一體式把手", value: "Roval Rapide Sprint CLX 與 Rapide Integrated" },
                { label: "傳動系統", value: "客製化 SRAM RED AXS" },
                { label: "重量", value: "6.6 公斤" }
            ],
            link: "查看完整規格"
        }
    },
    craft: {
        eyebrow: "Made in Racing Red",
        title: "每一輛，都是獨一無二的塗裝。",
        paragraphs: [
            "紅色釉彩覆蓋在一層銀色粉末之上，隨著光線角度變化，車架色澤會從深邃緋紅轉為閃耀的金屬亮紅。",
            "手工施作的墨洗效果在每一道邊緣漸層為深色。每一座車架都經過手工拋光與完工，讓 199 輛中的每一輛都獨一無二。"
        ],
        caption: "手工拋光與完工",
        mainImageAlt: "手工 Race Red 塗裝與座管編號銘牌特寫",
        details: [
            { title: "199 輛中的唯一", body: "座管上的專屬銘牌，標示每輛車的生產序號。" },
            { title: "全黑 RED AXS 套件", body: "客製化全黑 SRAM RED AXS 套件，搭配紅色陽極處理煞車卡鉗。" },
            { title: "黃邊胎與碳纖輻條", body: "Roval Rapide Sprint CLX 輪組搭配複合材料空力輻條，以及 30 mm Cotton TLR 外胎。" }
        ],
        detailImageAlt: "從座墊後方望向把手，可見紅色前煞車卡鉗",
        detailImageCaption: "全黑把手，紅色卡鉗"
    },
    racing: {
        eyebrow: "Made in Racing",
        title: "Tarmac SL9 的勝利實證。",
        intro: "Built for Legends 系列紀念 Specialized 的 2026 賽季。這一年，Specialized 在各個項目都拿下勝利，而 Tarmac SL9 在公路賽場上一馬當先。",
        stats: [
            { value: "4", label: "環法自行車賽分站冠軍", detail: "Tim Merlier 與 Remco Evenepoel" },
            { value: "6/9", label: "女子環法自行車賽分站冠軍", detail: "Demi Vollering、Lorena Wiebes 與 Kim Le Court-Pienaar" },
            { value: "2", label: "女子環法自行車賽領騎衫", detail: "黃衫與綠衫" }
        ],
        board: {
            title: "賽事成績",
            caption: "2026 女子環法自行車賽，騎乘 Tarmac SL9",
            columns: { rider: "車手", result: "成績", time: "完賽時間" },
            rows: [
                { race: "女子環法自行車賽", result: "總冠軍", rider: "Demi Vollering", time: "2:44:43", timeNote: "第 9 站" },
                { race: "女子環法自行車賽", result: "第 6 站冠軍", rider: "Kim Le Court-Pienaar", time: "4:01:48", timeNote: "第 6 站" }
            ]
        },
        disciplines: {
            title: "各項賽事的傳奇",
            items: [
                { name: "Epic 9", label: "越野登山車", result: "4 場世界盃冠軍" },
                { name: "Demo 11", label: "下坡登山車", result: "4 場世界盃冠軍" },
                { name: "Crux 5", label: "礫石公路車", result: "包辦 2026 Unbound 男子組頒獎台" }
            ]
        }
    },
    timeToFinish: {
        eyebrow: "Specialized 科學俱樂部隆重呈獻",
        title: "完賽時間。",
        subtitle: "唯一關鍵指標。",
        body: "Tarmac SL9 經過 Specialized 史上最全面的公路競賽模擬驗證。空氣力學、重量、滾動阻力、路面、天候與車手功率，全部整合成一個數字：在真實賽道上抵達終點所需的時間，從環法自行車賽賽段、列日－巴斯通－列日，到 2026 年蒙特婁世界錦標賽賽道。",
        highlights: [
            { value: "14", unit: "秒", text: "如果 Demi Vollering 在 2024 年女子環法自行車賽最後一個賽段騎乘 Tarmac SL9，她將快上 14 秒，而她當年僅以 4 秒之差落敗。這就是遺憾與歷史之間的差距。" },
            { value: "28", unit: "秒", text: "在模擬的 100 公里大環賽賽段中，比 Tarmac SL8 節省的時間。" }
        ],
        chart: {
            title: "模擬 100 公里大環賽賽段",
            subtitle: "與 Tarmac SL9 的時間差（秒）",
            columns: { bike: "車款", gap: "時間差", time: "完賽時間" },
            fastest: "最快",
            unit: "秒",
            note: "56 尺寸，所有車款皆搭載 SRAM RED AXS。資料來源：Specialized 競賽模擬。"
        }
    },
    aero: {
        eyebrow: "關鍵所在的空氣力學",
        title: "快上 4 瓦。",
        intro: "在時速 45 公里下與 Tarmac SL8 比較，風阻依真實比賽中最常見的小偏航角加權：70% 落在 ±5° 以內，95% 落在 ±10° 以內。",
        features: [
            { id: 'speed-sniffer', tag: "頭管", title: "Speed Sniffer", body: "頭管窄化 4 mm，迎風面積減少 10%。申請專利中的偏移式轉向管讓煞車油管沿單側走線，上段轉向管則維持標準 1 1/8 吋圓管規格。" },
            { id: 'fork', tag: "前叉", title: "雕塑式前叉", body: "更深的叉腳向外扭轉，引導氣流繞過車架；叉冠則緊密嵌入頭管與下管的接合處。" },
            { id: 'down-tube', tag: "下管", title: "下沉式下管", body: "每一根管件都依動態踩踏風洞數據重新塑形。下管位置更低，縮小與前叉及前輪之間的間隙。" },
            { id: 'win-fin', tag: "座管", title: "Win Fin", body: "座管向後延伸、緊貼後輪。專為突圍與衝刺時只帶一個水壺的實戰情境調校，在時速 45 公里下節省 0.5 瓦。" },
            { id: 'seatpost', tag: "座桿", title: "Rapide 座桿", body: "Specialized 史上最纖薄的座桿斷面，用在最關鍵的位置，同時保留原有的舒適性。" }
        ],
        imageAlt: "Speed Sniffer 窄化頭管與 Roval Rapide 一體式把手正面"
    },
    engineering: {
        eyebrow: "無可比擬的輕量化",
        title: "687 公克的 FACT 12r 碳纖維。",
        body: "比 SL8 快上 4 瓦，重量只多 2 公克。採用 FACT 12r 碳纖維與 Flow State Design 的車架，56 尺寸宣稱重量為 687 公克，Built for Legends LTD 整車重量則為 6.6 公斤。",
        weight: { value: "6.6", unit: "kg", label: "整車重量（56 尺寸）" },
        points: [
            { title: "Rider-First Engineered 騎士優先設計", body: "從 44 到 61 的每個尺寸都有專屬的碳纖維積層，讓每位騎士都能獲得相同的剛性、舒適性與操控平衡。" },
            { title: "騎乘品質，原汁原味", body: "剛性、舒適性與操控目標與 Tarmac SL8 完全一致。每一層碳纖維都身兼多職。" },
            { title: "動態踩踏人體模型", body: "於 Specialized Win Tunnel 風洞中以全身踩踏人體模型開發，每次測試之間皆以毫米級雷射定位確保姿勢一致。" },
            { title: "為真實道路而生", body: "可容納 32 mm 外胎，搭配 BSA 螺牙式五通與 UDH 勾爪。" }
        ],
        imageAlt: "S-Works Tarmac SL9 LTD Built for Legends 前方四分之三視角"
    },
    gallery: {
        eyebrow: "全方位細節",
        title: "細細品味每個細節。",
        items: {
            profile: "側面",
            frontQuarter: "前方四分之三視角",
            rearQuarter: "後方四分之三視角",
            seatTube: "座管與編號銘牌",
            cockpit: "把手與紅色煞車卡鉗",
            headTube: "Speed Sniffer 頭管"
        },
        previous: "上一張",
        next: "下一張",
        thumbnails: "選擇圖片"
    },
    specs: {
        eyebrow: "技術規格",
        title: "完整零件規格。",
        groups: [
            {
                title: "車架組",
                rows: [
                    { label: "車架", value: "S-Works Tarmac SL9，FACT 12r 碳纖維，Rider-First Engineered 騎士優先設計，Win Tunnel 風洞設計，CeramicSpeed SLT 頭碗軸承，螺牙式五通，12x142 mm 桶軸，平裝碟煞座，UDH 勾爪" },
                    { label: "前叉", value: "S-Works FACT 12r 碳纖維，12x100 mm 桶軸，平裝碟煞座" },
                    { label: "座桿", value: "S-Works Rapide 座桿，FACT 碳纖維，15 mm 後移量" },
                    { label: "座管束", value: "Tarmac 一體式楔形座管束" }
                ]
            },
            {
                title: "傳動系統",
                rows: [
                    { label: "變速把手", value: "SRAM RED AXS E1，油壓碟煞" },
                    { label: "前變速器", value: "SRAM RED AXS E1，直鎖式" },
                    { label: "後變速器", value: "SRAM RED AXS E1，12 速" },
                    { label: "大盤曲柄", value: "SRAM RED AXS E1，搭載 Quarq 功率計，50/37T" },
                    { label: "飛輪", value: "SRAM RED XG-1290 E1，12 速，10-36T" },
                    { label: "鏈條", value: "SRAM RED E1" },
                    { label: "五通", value: "CeramicSpeed BB Alpha，BSA DUB" }
                ]
            },
            {
                title: "煞車",
                rows: [
                    { label: "前煞車", value: "SRAM RED E1，油壓碟煞" },
                    { label: "後煞車", value: "SRAM RED E1，油壓碟煞" }
                ]
            },
            {
                title: "輪組與外胎",
                rows: [
                    { label: "前輪", value: "Roval Rapide Sprint CLX，無內胎，21 mm 內寬碳纖維輪圈，框高 63 mm，Win Tunnel 風洞設計，Roval LF18-F 花鼓，18 孔，Roval by ARRIS 複合材料空力輻條搭配鈦合金端頭" },
                    { label: "後輪", value: "Roval Rapide Sprint CLX，無內胎，21 mm 內寬碳纖維輪圈，框高 58 mm，Win Tunnel 風洞設計，Roval LF19-R 花鼓，24 孔，Roval by ARRIS 複合材料空力輻條搭配鈦合金端頭" },
                    { label: "外胎", value: "Cotton TLR，700x30，前後輪" },
                    { label: "內胎", value: "700x25-35，80 mm 法式氣嘴，TPU" }
                ]
            },
            {
                title: "把手與接觸點",
                rows: [
                    { label: "一體式把手", value: "Roval Rapide Cockpit，一體式把手龍頭" },
                    { label: "把手帶", value: "Supacaz Super Sticky Kush" },
                    { label: "座墊", value: "S-Works Power with Mirror" }
                ]
            },
            {
                title: "其他",
                rows: [
                    { label: "重量", value: "6.6 公斤（56 尺寸）" },
                    { label: "顏色", value: "Race Red" },
                    { label: "尺寸", value: "44、49、52、54、56、58" },
                    { label: "版本", value: "全球限量 199 輛獨立編號" }
                ]
            }
        ],
        note: "規格資料來自 Specialized，如有變更恕不另行通知。"
    },
    geometry: {
        eyebrow: "車架幾何",
        title: "競賽幾何，六種尺寸。",
        intro: "與 S-Works Tarmac SL9 車架組完全相同。選擇尺寸即可突顯對應數據。",
        sizeLabel: "尺寸",
        highlightLabel: "突顯尺寸",
        caption: "S-Works Tarmac SL9 LTD 各尺寸車架幾何",
        rows: {
            stack: "Stack 車架高度",
            reach: "Reach 車架前伸量",
            headTubeLength: "頭管長度",
            headTubeAngle: "頭管角度",
            seatTubeAngle: "座管角度",
            topTube: "上管長度（水平）",
            chainstay: "後下叉長度",
            bbDrop: "五通下降量",
            wheelbase: "軸距",
            forkOffset: "前叉偏移量",
            trail: "拖曳距",
            standover: "跨高"
        },
        note: "長度單位為公釐，角度單位為度。"
    },
    register: {
        eyebrow: "全球僅此 199 輛",
        title: "登記購買意願。",
        body: "留下您的聯絡資料與偏好尺寸，我們將與您聯繫，說明供貨狀況以及預訂一輛編號 Built for Legends LTD 的後續步驟。",
        officialLink: "前往 Specialized 官網",
        imageAlt: "S-Works Tarmac SL9 LTD Built for Legends 後方四分之三視角",
        form: {
            name: "姓名",
            namePlaceholder: "您的姓名",
            email: "電子郵件",
            emailPlaceholder: "you@example.com",
            phone: "電話",
            phonePlaceholder: "0912 345 678",
            optional: "選填",
            size: "偏好車架尺寸",
            notSure: "尚未確定",
            message: "留言",
            messagePlaceholder: "身高、騎乘經驗或任何問題",
            consent: "您的資料僅用於就此車款與您聯繫，我們絕不會分享給第三方。",
            submit: "登記購買意願",
            submitting: "傳送中",
            successTitle: "已完成登記。",
            successBody: "感謝您，我們已收到您的資料，將盡快與您聯繫。",
            again: "再次登記",
            errors: {
                name: "請輸入您的姓名。",
                email: "請輸入有效的電子郵件地址。",
                phone: "請輸入有效的電話號碼。",
                size: "請選擇車架尺寸。",
                message: "留言請勿超過 1,000 個字元。",
                generic: "發生錯誤，請稍後再試。",
                rateLimited: "請求次數過多，請稍候幾分鐘再試。"
            }
        }
    },
    configurator: {
        meta: {
            title: "Colnago C72 客製化",
            description: "客製化您的 Colnago C72 Road：從四款手工塗裝中挑選配色，選擇車架尺寸與車架組或整車規格，即可索取報價。"
        },
        eyebrow: "Colnago C72 Road",
        title: "打造您的 C72。",
        lead: "以接頭式碳纖維於義大利手工打造，接單後生產。選擇塗裝、尺寸與規格，我們將為您提供台灣報價。",
        officialLink: "開啟 Colnago 官方配置器",
        stageCaption: "車架組塗裝預覽",
        stageAlt: "{paint} 塗裝的 Colnago C72 車架組",
        stepLabel: "步驟",
        steps: {
            paint: "塗裝",
            size: "車架尺寸",
            build: "規格"
        },
        paints: {
            HFRD: { name: "黑／紅", description: "黑色車架，搭配紅色上管與後上叉。" },
            HFWS: { name: "珍珠白／銀", description: "珍珠白與銀色在黑色之上的細膩組合。" },
            HFBK: { name: "全黑", description: "亮面與霧面黑，點綴低調的古銅細節。" },
            HFTB: { name: "雙色藍", description: "深海軍藍，搭配淺藍色上管與後上叉。" }
        },
        paintNote: "每一款配色都引導視線，沿著後上叉流入上管的線條延伸。",
        sizeUnit: "cm",
        notSure: "尚未確定",
        sizeHint: "共七種尺寸，從 42 到 57。還不確定？我們會協助您挑選。",
        builds: {
            'frame-kit': { name: "車架組", detail: "車架、前叉、頭碗與 CC.02 一體式把手" },
            'dura-ace-sharq': { name: "Shimano Dura-Ace Di2", detail: "Fulcrum Sharq 57 輪組" },
            'dura-ace-enve': { name: "Shimano Dura-Ace Di2", detail: "Enve SES 4.5 輪組" },
            'super-record-bora': { name: "Campagnolo Super Record 13", detail: "Campagnolo Bora Ultra WTO 輪組" },
            'red-axs-enve': { name: "SRAM RED AXS", detail: "Enve SES 4.5 輪組，含功率計" }
        },
        buildNote: "齒比、曲柄長度、把手尺寸與座墊，會在準備報價時與您逐一確認。",
        summary: {
            title: "您的 C72",
            paint: "塗裝",
            size: "尺寸",
            build: "規格",
            notChosen: "尚未選擇",
            price: "售價",
            priceValue: "依台灣報價",
            cta: "索取報價",
            copyLink: "複製連結",
            copied: "已複製連結"
        },
        quote: {
            eyebrow: "索取報價",
            title: "把您的 C72 傳給我們。",
            body: "每一輛 C72 都在義大利接單後打造，因此我們會親自與您確認價格、尺寸與交期。送出這份配置與聯絡資料，我們將回覆您的報價。",
            configTitle: "您的配置",
            edit: "修改",
            name: "姓名",
            namePlaceholder: "您的姓名",
            email: "電子郵件",
            emailPlaceholder: "you@example.com",
            phone: "電話",
            phonePlaceholder: "0912 345 678",
            optional: "選填",
            message: "尺寸備註",
            messagePlaceholder: "身高、跨下長、偏好的曲柄長度或其他需求",
            consent: "您的資料僅用於準備報價，我們絕不會分享給第三方。",
            submit: "送出報價需求",
            submitting: "傳送中",
            successTitle: "已送出報價需求。",
            successBody: "感謝您，我們已收到您的配置，將盡快回覆報價。",
            again: "重新配置一輛 C72",
            errors: {
                paint: "請選擇塗裝。",
                size: "請選擇車架尺寸。",
                build: "請選擇規格。",
                name: "請輸入您的姓名。",
                email: "請輸入有效的電子郵件地址。",
                phone: "請輸入有效的電話號碼。",
                message: "備註請勿超過 1,000 個字元。",
                config: "請先完成上方的配置。",
                generic: "發生錯誤，請稍後再試。",
                rateLimited: "請求次數過多，請稍候幾分鐘再試。"
            }
        },
        highlights: {
            eyebrow: "為什麼選擇 C72",
            title: "以從容的方式打造。",
            intro: "在一體成型車架當道的時代，C72 堅持 Colnago 的接頭式工法：先製作管件與接頭，再以手工黏合、修整與塗裝。",
            imageAlt: "黑／紅塗裝的 Colnago C72，搭載 SRAM RED AXS 與 Enve 輪組，側面",
            imageCaption: "圖為黑／紅塗裝，搭載 SRAM RED AXS 與 Enve SES 4.5",
            items: [
                { value: "7", label: "根碳纖維管件接頭式黏合", body: "每根管件的積層都個別調校，再於義大利組裝並手工完工。" },
                { value: "895 g", label: "宣稱車架重量", body: "48.5 尺寸、未塗裝。比 C68 輕 30 公克，但減重從來不是主要目標。" },
                { value: "35 mm", label: "輪胎間隙", body: "以 30 mm 外胎為設計基準，700C 輪組最多可容納 35 mm。" },
                { value: "CC.02", label: "一體式把手", body: "比 CC.01 輕 15 公克，前伸更短、外擴更大，下把位操控更穩。" },
                { value: "BSA 68", label: "螺牙式五通", body: "相容 Shimano、SRAM 與 Campagnolo 套件。" },
                { value: "3,000", label: "年產量上限", body: "產量有限，每一輛都在接單後打造。" }
            ],
            storage: {
                title: "下管隱藏式收納",
                body: "與車架齊平的收納艙，蓋板同時是水壺架座，內含迷你棘輪扳手、起子頭、TPU 內胎與 CO2 充氣頭。"
            },
            legal: "Colnago 與 C72 為 Colnago 之商標。產品攝影由 Colnago 提供。"
        }
    },
    footer: {
        tagline: "一輛自行車統領一切。199 輛獨立編號，以手工完成 Race Red 塗裝。",
        explore: "探索",
        official: "官方產品頁面",
        officialLink: "Specialized 官網上的 S-Works Tarmac SL9 LTD",
        legal: "Specialized、S-Works、Tarmac 與 Roval 為 Specialized Bicycle Components, Inc. 之商標。產品攝影由 Specialized 提供。",
        backToTop: "回到頂端"
    }
}
